import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditLog } from '@shared/models/audit-log.model';
import { Pagination } from '@shared/models/pagination.model';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';

import {
  ReduceToClearListContent,
  ReduceToClearSearchCriteria,
  ReduceToClearViewResponse
} from '../model/reduce-to-clear.model';

@Injectable({
  providedIn: 'root'
})
export class ReduceToClearService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.rtc;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getReduceToClearList(criteria: ReduceToClearSearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.list);

    return this.http.get<Pagination<ReduceToClearListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getReduceToClearView(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.view, { docNo });

    return this.http.get<Pagination<ReduceToClearViewResponse>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getReduceToClearHistory(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.history, { docNo });

    return this.http.get<{ auditLogs: AuditLog[] }>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  override getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrlWithStoreNo(this.envService.fileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }
}
